import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import BulmaTagsInput from '@creativebulma/bulma-tagsinput/src/js/index';
import ErrorNotification from './ErrorNotification';

const setCittaValue = (item, formik, objTagsInput) => {
	formik.setFieldValue('citta', objTagsInput.items);
	return item;
};
const initObjTagsBulma = (formik) => {
	const objTagsInput = new BulmaTagsInput('#citta', {
		source: async (value) =>
			fetch(
				`${window.location.origin}/wp-json/tsm-v1/get_cities_like?q=${value}`
			).then((response) => response.json()),
	});
	objTagsInput.on('after.add', (item) => {
		return setCittaValue(item, formik, objTagsInput);
	});
	objTagsInput.on('after.remove', (item) => {
		return setCittaValue(item, formik, objTagsInput);
	});
};

const CustomTagsInputComponent = ({ className, placeholder, formik }) => {
	useEffect(() => {
		initObjTagsBulma(formik);
	}, []);

	/* eslint-disable jsx-a11y/autocomplete-valid */
	return (
		<div className="control">
			<label htmlFor="citta" className="label">
				{placeholder}
				<input
					type="tags"
					name="citta"
					data-type="tags"
					value=""
					id="citta"
					data-item-text="name"
					data-item-value="numericCode"
					data-case-sensitive="false"
					className={className}
					placeholder={placeholder}
					autoComplete="none"
				/>
			</label>
			<ErrorNotification formik={formik} field="citta" />
		</div>
	);
	/* eslint-enable jsx-a11y/autocomplete-valid */
};

CustomTagsInputComponent.propTypes = {
	formik: PropTypes.instanceOf(Object).isRequired,
	placeholder: PropTypes.instanceOf(String).isRequired,
	className: PropTypes.instanceOf(String).isRequired,
};

export default CustomTagsInputComponent;
